export default {
	title: '轴承库',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	noData: {
		title: '暂无轴承数据',
		description: '当前没有找到相关的轴承数据'
	},
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		designation: '轴承名称',
		brand: '轴承品牌',
		bpfo: '外圈故障特征频率',
		bpfi: '内圈故障特征频率',
		bsf: '滚动体故障特征频率',
		ftf: '保持架故障特征频率',
		placeholder: {
			designation: '请输入轴承名称',
			brand: '请输入轴承品牌',
			bpfo: '请输入外圈故障特征频率',
			bpfi: '请输入内圈故障特征频率',
			bsf: '请输入滚动体故障特征频率',
			ftf: '请输入保持架故障特征频率'
		}
	},
	table: {
		designation: '轴承名称',
		brand: '轴承品牌',
		bpfo: '外圈故障特征频率',
		bpfi: '内圈故障特征频率',
		bsf: '滚动体故障特征频率',
		ftf: '保持架故障特征频率'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	}
}
